import Smiley from 'app/design/images/smiley';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import type { FreeSubParams } from './free-sub';

export function FreeSubClosing({
  userGotFreeSub,
  userNowContributor,
}: Pick<FreeSubParams, 'userGotFreeSub' | 'userNowContributor'>) {
  const { t } = useTranslation('free-sub');

  return (
    <>
      {userGotFreeSub && !userNowContributor ? <Smiley /> : null}
      {userGotFreeSub ? (
        <Text style={{ fontSize: 18, textAlign: 'center' }} variant="bodyBase">
          {t('spreadTheLoveText')}
        </Text>
      ) : null}
    </>
  );
}
